import auth from './auth';
import user from './user';
import trip from './trip';
import booking from './booking';
import message from './message';
import payment from './payment';
import mail from './mail';
import config from './config';
import search from './search';
import customize from './customize';
import section from './section';
import article from './article';
import city from './city';
import topicAnalytic from './topic-analytic';
import promo from './promo';
import calendar from './calendar';
import dashboard from './dashboard';
import redirect from './redirect';
import tripGroup from './trip-group';
import swapRequest from './swap-request';
import testing from './testing';
import affiliate from './affiliate';
import influencer from './influencer';
import review from './review';
import replace from './replace';
import restaurant from './restaurant';
import souvenir from './souvenir';
import biennale from './biennale';
import pricing from './pricing';
import sms from './sms';
import partner from './partner';
import fruitMarket from './fruit-market';
import localCommunity from './local-community';
import walkingTour from './walking-tour';
import cxHandoff from './cx-handoff';

/* eslint-disable */
export const reducers = {
  auth,
  user,
  trip,
  booking,
  message,
  payment,
  mail,
  config,
  search,
  customize,
  section,
  article,
  city,
  topicAnalytic,
  promo,
  calendar,
  dashboard,
  redirect,
  tripGroup,
  swapRequest,
  affiliate,
  influencer,
  testing,
  review,
  replace,
  restaurant,
  souvenir,
  biennale,
  sms,
  partner,
  pricing,
  fruitMarket,
  localCommunity,
  walkingTour,
  cxHandoff,
};



// WEBPACK FOOTER //
// ./src/ducks/index.js